import { createEl, appendChild, getParent, getChild, innerHtml, textContent } from '@/scripts/utils/legacy-dom.js';

// Copy from snippets/waitlist-form.liquid (theme settings + the PDP's product title).
let config = null;
function getConfig() {
    if (config) return config;
    try {
        config = JSON.parse(document.querySelector('[data-waitlist-config]')?.textContent || '{}');
    } catch (e) {
        config = {};
    }
    return config;
}

function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
}

export default function waitlistForm(options) {
    options = options || {};
    const {el, insertMethod, remove, variantId, variantName, variant = null, waitlist = false, listId = 'RXE53a'} = options;

    // Clear any form this call would replace, scoped to where it inserts: `before` puts the
    // container next to `el`, anything else inside it. A document-wide lookup removes whichever
    // form comes first in the page, which on a collection grid can belong to a different card.
    const scope = !el ? document : (insertMethod === 'before' ? (el.parentNode || document) : el);
    const existing = scope.querySelector('.waitlist');
    if (existing) {
        existing.remove();
    }

    // `remove` (and a missing `el`) means clear only — without this the insert at the end of
    // the function runs against an undefined `el`.
    if (!el || remove) {
        return;
    }

    if (!!variant?.available && !waitlist) {
        return;
    }

    const {waitlist1 = '', waitlist2 = '', cta = '', productTitle = ''} = getConfig();

    const container = createEl('div', 'out-of-stock-msg description waitlist');
    // waitlist1/waitlist2 are merchant-authored theme settings and may contain markup.
    innerHtml(container, `<p>${waitlist1}&nbsp;<span class="out-of-stock-msg-variant"><strong>${escapeHtml(productTitle)} - ${escapeHtml(variantName || '')}</strong></span>&nbsp;${waitlist2}</p>`);
    const form = createEl('form', 'waitlist-form');
    form.setAttribute('data-variant_id', variantId);
    const notifyMeWrapper = createEl('div', 'notify-me-wrapper');
    const input = createEl('input');
    input.type = 'email';
    input.placeholder = 'Email...';
    const button = createEl('button', 'button styled-submit');
    textContent(button, cta);

    appendChild(notifyMeWrapper, [input, button]);
    appendChild(form, notifyMeWrapper);
    appendChild(container, form);

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        const thisContainer = getParent(e.target, 'waitlist');
        const thisForm = getChild(thisContainer, '.waitlist-form');
        const variantId = thisForm.getAttribute('data-variant_id');
        const email = getChild(thisForm, 'input[type="email"]').value;

        // Both guards run before the button is touched — bailing after disabling it left the
        // shopper looking at "Processing..." forever.
        if (!email || !variantId) {
            return;
        }

        const thisButton = getChild(thisForm, 'button');
        thisButton.disabled = true;
        const buttonText = textContent(thisButton);
        textContent(thisButton, 'Processing...');

        const klaviyoOptions = {
            vendor: 'klaviyo-subscribe',
            action: 'backinstock',
            email,
            signup_location: 'Product Form',
            // The variant this form was stamped with, not the one captured in the closure —
            // those diverge as soon as a container outlives the call that built it, and then
            // the wrong variant is booked.
            variant: variantId,
            list_id: listId,
        };

        window.wb_apihelper(klaviyoOptions, function (err, res) {
            thisButton.disabled = false;
            textContent(thisButton, buttonText);
            if (err) {
                return alert(res.message);
            }
            innerHtml(thisContainer, '<p>Thank you! We will notify you when this product is available.</p>');
        });
    });

    if (insertMethod === 'before') {
        el.before(container);
    } else {
        appendChild(el, container);
    }
}
